import React from "react"
import styled from "styled-components"
import CardHero from "../../card/cardHero/CardHero"
import PlayerCard from "../../card/playerCard/PlayerCard"
import { Icons } from "../../data/ChildHeroSectionData"
import ChildThirdSectionInformation from "./ChildThirdSectionInformation"

export default function ChildHeroSection() {
  return (
    <>
      <Wrapper>
        <ChildWrapper>
          <HeroWrapper>
            <HeroWrapperTextContainer>
              <TextWrapper>BUILD ANYTHING</TextWrapper>
              <TextHeroWrapper>
                Build whatever you want, seriously.
              </TextHeroWrapper>
              <TextWrapperDescription>
                Because veu is at a very low level. It never pushes you to write
                too much code. Compatible with all applications very easily. veu
                is simple. You can manipulate the same code in other web
                projects
              </TextWrapperDescription>
            </HeroWrapperTextContainer>
            <IconsWrapper>
              <IconsHero>
                {Icons.map(item => {
                  return (
                    <>
                      <IconsHeroContainer>
                        <LazyLoadWrapper>
                          <ImageIcons src={item.image} alt={item.title} />
                        </LazyLoadWrapper>
                      </IconsHeroContainer>
                    </>
                  )
                })}
              </IconsHero>
              <SearchWrapper>
                <SearchInputWrapper>
                  <label for="search">
                    <SearchInputIconWrapper>
                      <img
                        src="https://designcode.io/images/icons/search.svg"
                        alt=""
                        style={{ margin: "0px" }}
                      />
                    </SearchInputIconWrapper>
                    <InputWrapper placeholder="Search" />
                  </label>
                </SearchInputWrapper>
              </SearchWrapper>
            </IconsWrapper>
            <PlayerCard />
            <CardHero />
          </HeroWrapper>
          <ChildThirdSectionInformation />
        </ChildWrapper>
      </Wrapper>
    </>
  )
}

const Wrapper = styled.div``

const ChildWrapper = styled.div`
  position: relative;
  padding-top: 85px;
  height: 1222px;

  @media (mx-width: 1280px) {
    height: 1306px;
  }

  @media (max-width: 1254px) {
    padding-top: 150px;
  }
`

const HeroWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 380px auto;
  column-gap: 80px;
  max-width: 1234px;
  margin: 0 auto;
  padding: 0 30px;
  align-items: flex-end;
  pointer-events: none;

  @media (max-width: 1280px) {
    grid-template-columns: 1fr;
  }
`

const HeroWrapperTextContainer = styled.div`
  position: relative;
  display: grid;
  gap: 20px;
  max-width: 380px;
`

const TextWrapper = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  text-transform: uppercase;
  margin: 0px;
  color: rgba(0, 0, 0, 0.7);
`

const TextHeroWrapper = styled.h2`
  font-style: normal;
  font-weight: bold;
  margin: 0px;
  font-size: 40px;
  color: rgb(0, 0, 0);
`

const TextWrapperDescription = styled.p`
  font-size: 17px;
  line-height: 130%;
  font-style: normal;
  font-weight: normal;
  margin: 0px;
  color: rgb(0, 0, 0);
`

const IconsWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  margin: 20px 0px;
  pointer-events: visible;

  @media (max-width: 1280px) {
    top: 20px;
  }
`

const IconsHero = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  column-gap: 20px;
`

const IconsHeroContainer = styled.div`
  cursor: pointer;
`

const LazyLoadWrapper = styled.div``

const ImageIcons = styled.img`
  width: 44px;
  height: 44px;
  margin: 0px;
  opacity: 1;
`

const SearchWrapper = styled.div`
  max-width: 204px;
  width: 204px;
`

const SearchInputWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 44px;
`

const SearchInputIconWrapper = styled.div`
  position: absolute;
  z-index: 2;
  top: 10px;
  left: 10px;
`

const InputWrapper = styled.input`
  height: 100%;
  width: 100%;
  background: linear-gradient(
    rgba(99, 106, 150, 0.4) 0%,
    rgba(182, 186, 214, 0.25) 100%
  );
  border: none;
  border-radius: 30px;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 20px 40px,
    rgba(255, 255, 255, 0.3) 0px 0px 0px 0.5px inset;
  box-sizing: border-box;
  padding: 10px 42px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: rgb(255, 255, 255);
  line-height: 130%;
  transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1) 0s;

  :focus {
    outline: none;
    padding-left: 42px;
    box-shadow: rgba(47, 184, 255, 0.3) 0px 10px 40px,
      rgb(47, 184, 255) 0px 0px 0px 1px inset;
    background: linear-gradient(
      rgba(24, 32, 79, 0.4) 0%,
      rgba(24, 32, 79, 0.25) 100%
    );
  }

  ::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }

  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) and (prefers-color-scheme: light) {
    background: linear-gradient(
      rgba(99, 106, 150, 0.8) 0%,
      rgba(182, 186, 214, 0.6) 100%
    );
  }
`
